var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconMessages(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 12C20 9.89454 18.4384 8.09303 16.2276 7.35596C17.0288 8.38457 17.5 9.63244 17.5 11C17.5 13.7047 15.6571 15.9412 13.0629 16.9394C13.3682 16.9793 13.6812 17 14 17C14.384 17 14.7597 16.9699 15.1236 16.9125C15.5869 17.5961 16.4302 18.0161 18.0132 18.0161C17.5754 17.3699 17.2726 16.7218 17.1869 16.2372C18.8768 15.3527 20 13.7857 20 12Z",
    fill: "#2A5885"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.98 17C7.56784 17 8.413 16.5858 8.8756 15.9124C9.23982 15.9699 9.61569 16 10 16C13.3137 16 16 13.7614 16 11C16 8.23858 13.3137 6 10 6C6.68629 6 4 8.23858 4 11C4 12.7848 5.12223 14.3512 6.81076 15.2359C6.73166 15.7122 6.42585 16.3571 5.98 17Z",
    fill: "#6366F1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMessages);
export default __webpack_public_path__ + "static/media/icon-messages.650272f560c792033d9b4f44347b9944.svg";
export { ForwardRef as ReactComponent };